import { createBrowserRouter, Navigate } from 'react-router';
import BaseLayout from '@layouts/index';
import { authGuardLoader } from '@loaders/authGuardLoader';

import Loader from '@components/Loader';
import ReportErrorBoundary from '@components/ReportErrorBoundary';
import LoadingPage from '@pages/Loading';
import LoginPage from '@pages/Login';
import NotFoundPage from '@pages/NotFound';
import ReportPage from '@pages/ReportPage';

import { E_APP_ROUTES } from './enums';

export const router = createBrowserRouter([
  {
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: (
          <Navigate
            to={E_APP_ROUTES.LOGIN}
            replace
          />
        ),
      },
      {
        path: E_APP_ROUTES.LOGIN,
        element: <LoginPage />,
      },
      {
        path: E_APP_ROUTES.LOADING,
        element: <LoadingPage />,
        loader: authGuardLoader,
        hydrateFallbackElement: <Loader />,
        errorElement: <ReportErrorBoundary />,
      },
      {
        path: E_APP_ROUTES.REPORT,
        element: <ReportPage />,
        loader: authGuardLoader,
        hydrateFallbackElement: <Loader />,
        errorElement: <ReportErrorBoundary />,
      },
      {
        path: E_APP_ROUTES.NOT_FOUND,
        element: <NotFoundPage />,
      },
    ],
  },
]);
